export default "__VITE_ASSET__9b0b4a43__"